import React from 'react';
import { Box } from '@intechprev/componentes-web';
import { Link } from 'react-router-dom';

export const Contato: React.FC = () => {

  return (
    <Box titulo={"Dúvidas?"} subtitulo="Entre em contato conosco!">
      Telefone:
      (98) 3217-2255 - Maranhão
      (91) 3038-0092 - Pará
      <br />
      Email: faleconosco@eqtprev.com.br
      <br />
      Ou envie-nos uma mensagem, clicando <Link to={"/relacionamento"} className={""}>aqui!</Link>
    </Box>
  );
}